import { ELanguages } from '.'

enum EAge {
  en = 'Age',
  es = 'Edad',
  fr = 'Âge',
  de = 'Alter',
  pt = 'Idade',
  cs = 'Věk',
  fi = 'Ikä',
}

enum EAlone {
  en = 'Alone',
  es = 'Solo',
  fr = 'Seul',
  de = 'Allein',
  pt = 'Sozinho',
  cs = 'Sám',
  fi = 'Yksin',
}

enum EAmazing {
  en = 'Amazing',
  es = 'Asombroso',
  fr = 'Incroyable',
  de = 'Erstaunlich',
  pt = 'Incrível',
  cs = 'Úžasný',
  fi = 'Uskomaton',
}

enum EAnger {
  en = 'Anger',
  es = 'Ira',
  fr = 'Colère',
  de = 'Wut',
  pt = 'Raiva',
  cs = 'Hněv',
  fi = 'Viha',
}

enum EArchitecture {
  en = 'Architecture',
  es = 'Arquitectura',
  fr = 'Architecture',
  de = 'Architektur',
  pt = 'Arquitetura',
  cs = 'Architektura',
  fi = 'Arkkitehtuuri',
}

enum EArt {
  en = 'Art',
  es = 'Arte',
  fr = 'Art',
  de = 'Kunst',
  pt = 'Arte',
  cs = 'Umění',
  fi = 'Taide',
}

enum EAttitude {
  en = 'Attitude',
  es = 'Actitud',
  fr = 'Attitude',
  de = 'Einstellung',
  pt = 'Atitude',
  cs = 'Postoj',
  fi = 'Asenne',
}

enum EBeauty {
  en = 'Beauty',
  es = 'Belleza',
  fr = 'Beauté',
  de = 'Schönheit',
  pt = 'Beleza',
  cs = 'Krása',
  fi = 'Kauneus',
}

enum EBest {
  en = 'Best',
  es = 'Mejor',
  fr = 'Meilleur',
  de = 'Beste',
  pt = 'Melhor',
  cs = 'Nejlepší',
  fi = 'Paras',
}

enum EBirthday {
  en = 'Birthday',
  es = 'Cumpleaños',
  fr = 'Anniversaire',
  de = 'Geburtstag',
  pt = 'Aniversário',
  cs = 'Narozeniny',
  fi = 'Syntymäpäivä',
}

enum ECar {
  en = 'Car',
  es = 'Coche',
  fr = 'Voiture',
  de = 'Auto',
  pt = 'Carro',
  cs = 'Auto',
  fi = 'Auto',
}

enum EChange {
  en = 'Change',
  es = 'Cambio',
  fr = 'Changement',
  de = 'Veränderung',
  pt = 'Mudança',
  cs = 'Změna',
  fi = 'Muutos',
}

enum ECommunication {
  en = 'Communication',
  es = 'Comunicación',
  fr = 'Communication',
  de = 'Kommunikation',
  pt = 'Comunicação',
  cs = 'Komunikace',
  fi = 'Viestintä',
}

enum EComputers {
  en = 'Computers',
  es = 'Computadoras',
  fr = 'Ordinateurs',
  de = 'Computer',
  pt = 'Computadores',
  cs = 'Počítače',
  fi = 'Tietokoneet',
}

enum ECool {
  en = 'Cool',
  es = 'Genial',
  fr = 'Cool',
  de = 'Cool',
  pt = 'Legal',
  cs = 'Skvělý',
  fi = 'Siisti',
}

enum ECourage {
  en = 'Courage',
  es = 'Coraje',
  fr = 'Courage',
  de = 'Mut',
  pt = 'Coragem',
  cs = 'Odvaha',
  fi = 'Rohkeus',
}

enum EDad {
  en = 'Dad',
  es = 'Papá',
  fr = 'Papa',
  de = 'Vater',
  pt = 'Papai',
  cs = 'Táta',
  fi = 'Isä',
}

enum EDating {
  en = 'Dating',
  es = 'Citas',
  fr = 'Rencontres',
  de = 'Dating',
  pt = 'Namoro',
  cs = 'Seznamování',
  fi = 'Treffit',
}

enum EDeath {
  en = 'Death',
  es = 'Muerte',
  fr = 'Mort',
  de = 'Tod',
  pt = 'Morte',
  cs = 'Smrt',
  fi = 'Kuolema',
}

enum EDesign {
  en = 'Design',
  es = 'Diseño',
  fr = 'Design',
  de = 'Design',
  pt = 'Design',
  cs = 'Design',
  fi = 'Suunnittelu',
}

enum EDreams {
  en = 'Dreams',
  es = 'Sueños',
  fr = 'Rêves',
  de = 'Träume',
  pt = 'Sonhos',
  cs = 'Sny',
  fi = 'Unelmat',
}

enum EEnvironmental {
  en = 'Environmental',
  es = 'Ambiental',
  fr = 'Environnemental',
  de = 'Umweltbezogen',
  pt = 'Ambiental',
  cs = 'Environmentální',
  fi = 'Ympäristö',
}

enum EEquality {
  en = 'Equality',
  es = 'Igualdad',
  fr = 'Égalité',
  de = 'Gleichheit',
  pt = 'Igualdade',
  cs = 'Rovnost',
  fi = 'Tasa-arvo',
}

enum EExperience {
  en = 'Experience',
  es = 'Experiencia',
  fr = 'Expérience',
  de = 'Erfahrung',
  pt = 'Experiência',
  cs = 'Zkušenost',
  fi = 'Kokemus',
}

enum EFailure {
  en = 'Failure',
  es = 'Fracaso',
  fr = 'Échec',
  de = 'Fehler',
  pt = 'Falha',
  cs = 'Selhání',
  fi = 'Epäonnistuminen',
}

enum EFaith {
  en = 'Faith',
  es = 'Fe',
  fr = 'Foi',
  de = 'Glaube',
  pt = 'Fé',
  cs = 'Víra',
  fi = 'Usko',
}

enum EFamily {
  en = 'Family',
  es = 'Familia',
  fr = 'Famille',
  de = 'Familie',
  pt = 'Família',
  cs = 'Rodina',
  fi = 'Perhe',
}

enum EFamous {
  en = 'Famous',
  es = 'Famoso',
  fr = 'Célèbre',
  de = 'Berühmt',
  pt = 'Famoso',
  cs = 'Slavný',
  fi = 'Kuuluisa',
}

enum EFear {
  en = 'Fear',
  es = 'Miedo',
  fr = 'Peur',
  de = 'Angst',
  pt = 'Medo',
  cs = 'Strach',
  fi = 'Pelko',
}

enum EFitness {
  en = 'Fitness',
  es = 'Aptitud',
  fr = 'Fitness',
  de = 'Fitness',
  pt = 'Aptidão',
  cs = 'Fitness',
  fi = 'Kunto',
}

enum EForgiveness {
  en = 'Forgiveness',
  es = 'Perdón',
  fr = 'Pardon',
  de = 'Vergebung',
  pt = 'Perdão',
  cs = 'Odpouštění',
  fi = 'Anteeksianto',
}

enum EFreedom {
  en = 'Freedom',
  es = 'Libertad',
  fr = 'Liberté',
  de = 'Freiheit',
  pt = 'Liberdade',
  cs = 'Svoboda',
  fi = 'Vapaus',
}

enum EFriendship {
  en = 'Friendship',
  es = 'Amistad',
  fr = 'Amitié',
  de = 'Freundschaft',
  pt = 'Amizade',
  cs = 'Přátelství',
  fi = 'Ystävyys',
}

enum EFunny {
  en = 'Funny',
  es = 'Divertido',
  fr = 'Drôle',
  de = 'Lustig',
  pt = 'Engraçado',
  cs = 'Vtipný',
  fi = 'Hauska',
}

enum EFuture {
  en = 'Future',
  es = 'Futuro',
  fr = 'Futur',
  de = 'Zukunft',
  pt = 'Futuro',
  cs = 'Budoucnost',
  fi = 'Tulevaisuus',
}

enum EGod {
  en = 'God',
  es = 'Dios',
  fr = 'Dieu',
  de = 'Gott',
  pt = 'Deus',
  cs = 'Bůh',
  fi = 'Jumala',
}

enum EGood {
  en = 'Good',
  es = 'Bueno',
  fr = 'Bon',
  de = 'Gut',
  pt = 'Bom',
  cs = 'Dobrý',
  fi = 'Hyvä',
}

enum EGovernment {
  en = 'Government',
  es = 'Gobierno',
  fr = 'Gouvernement',
  de = 'Regierung',
  pt = 'Governo',
  cs = 'Vláda',
  fi = 'Hallitus',
}

enum EGraduation {
  en = 'Graduation',
  es = 'Graduación',
  fr = 'Remise des diplômes',
  de = 'Abschluss',
  pt = 'Formatura',
  cs = 'Promoce',
  fi = 'Valmistuminen',
}

enum EGreat {
  en = 'Great',
  es = 'Genial',
  fr = 'Génial',
  de = 'Großartig',
  pt = 'Ótimo',
  cs = 'Skvělý',
  fi = 'Upea',
}

enum EHappiness {
  en = 'Happiness',
  es = 'Felicidad',
  fr = 'Bonheur',
  de = 'Glück',
  pt = 'Felicidade',
  cs = 'Štěstí',
  fi = 'Onni',
}

enum EHistory {
  en = 'History',
  es = 'Historia',
  fr = 'Histoire',
  de = 'Geschichte',
  pt = 'História',
  cs = 'Historie',
  fi = 'Historia',
}

enum EHome {
  en = 'Home',
  es = 'Hogar',
  fr = 'Domicile',
  de = 'Zuhause',
  pt = 'Casa',
  cs = 'Domov',
  fi = 'Koti',
}

enum EHope {
  en = 'Hope',
  es = 'Esperanza',
  fr = 'Espoir',
  de = 'Hoffnung',
  pt = 'Esperança',
  cs = 'Naděje',
  fi = 'Toivo',
}

enum EHumor {
  en = 'Humor',
  es = 'Humor',
  fr = 'Humour',
  de = 'Humor',
  pt = 'Humor',
  cs = 'Humor',
  fi = 'Huumori',
}

enum EImagination {
  en = 'Imagination',
  es = 'Imaginación',
  fr = 'Imagination',
  de = 'Imagination',
  pt = 'Imaginação',
  cs = 'Představivost',
  fi = 'Mielikuvitus',
}

enum EInspirational {
  en = 'Inspirational',
  es = 'Inspirador',
  fr = 'Inspirationnel',
  de = 'Inspirierend',
  pt = 'Inspirador',
  cs = 'Inspirativní',
  fi = 'Inspiroiva',
}

enum EIntelligence {
  en = 'Intelligence',
  es = 'Inteligencia',
  fr = 'Intelligence',
  de = 'Intelligenz',
  pt = 'Inteligência',
  cs = 'Inteligence',
  fi = 'Älykkyys',
}

enum EJealousy {
  en = 'Jealousy',
  es = 'Celos',
  fr = 'Jalousie',
  de = 'Eifersucht',
  pt = 'Ciúmes',
  cs = 'Žárlivost',
  fi = 'Mustasukkaisuus',
}

enum EKnowledge {
  en = 'Knowledge',
  es = 'Conocimiento',
  fr = 'Connaissance',
  de = 'Wissen',
  pt = 'Conhecimento',
  cs = 'Znalosti',
  fi = 'Tietämys',
}

enum ELeadership {
  en = 'Leadership',
  es = 'Liderazgo',
  fr = 'Leadership',
  de = 'Führung',
  pt = 'Liderança',
  cs = 'Vedení',
  fi = 'Johtajuus',
}

enum ELearning {
  en = 'Learning',
  es = 'Aprendizaje',
  fr = 'Apprentissage',
  de = 'Lernen',
  pt = 'Aprendizado',
  cs = 'Učení',
  fi = 'Oppiminen',
}

enum ELegal {
  en = 'Legal',
  es = 'Legal',
  fr = 'Légal',
  de = 'Legal',
  pt = 'Legal',
  cs = 'Právní',
  fi = 'Oikeudellinen',
}

enum ELife {
  en = 'Life',
  es = 'Vida',
  fr = 'Vie',
  de = 'Leben',
  pt = 'Vida',
  cs = 'Život',
  fi = 'Elämä',
}

enum ELove {
  en = 'Love',
  es = 'Amor',
  fr = 'Amour',
  de = 'Liebe',
  pt = 'Amor',
  cs = 'Láska',
  fi = 'Rakkaus',
}

enum EMarriage {
  en = 'Marriage',
  es = 'Matrimonio',
  fr = 'Mariage',
  de = 'Ehe',
  pt = 'Casamento',
  cs = 'Manželství',
  fi = 'Avioliitto',
}

enum EMedical {
  en = 'Medical',
  es = 'Médico',
  fr = 'Médical',
  de = 'Medizinisch',
  pt = 'Médico',
  cs = 'Lékařský',
  fi = 'Lääketieteellinen',
}

enum EMen {
  en = 'Men',
  es = 'Hombres',
  fr = 'Hommes',
  de = 'Männer',
  pt = 'Homens',
  cs = 'Muži',
  fi = 'Miehet',
}

enum EMom {
  en = 'Mom',
  es = 'Mamá',
  fr = 'Maman',
  de = 'Mama',
  pt = 'Mãe',
  cs = 'Máma',
  fi = 'Äiti',
}

enum EMoney {
  en = 'Money',
  es = 'Dinero',
  fr = 'Argent',
  de = 'Geld',
  pt = 'Dinheiro',
  cs = 'Peníze',
  fi = 'Rahat',
}

enum EMorning {
  en = 'Morning',
  es = 'Mañana',
  fr = 'Matin',
  de = 'Morgen',
  pt = 'Manhã',
  cs = 'Ráno',
  fi = 'Aamu',
}

enum EMovies {
  en = 'Movies',
  es = 'Películas',
  fr = 'Films',
  de = 'Filme',
  pt = 'Filmes',
  cs = 'Filmy',
  fi = 'Elokuvat',
}

enum ESuccess {
  en = 'Success',
  es = 'Éxito',
  fr = 'Succès',
  de = 'Erfolg',
  pt = 'Sucesso',
  cs = 'Úspěch',
  fi = 'Menestys',
}

export const translationMapQuotes: Record<
  string,
  Record<ELanguages, string>
> = {
  age: EAge,
  alone: EAlone,
  amazing: EAmazing,
  anger: EAnger,
  architecture: EArchitecture,
  art: EArt,
  attitude: EAttitude,
  beauty: EBeauty,
  best: EBest,
  birthday: EBirthday,
  car: ECar,
  change: EChange,
  communication: ECommunication,
  computers: EComputers,
  cool: ECool,
  courage: ECourage,
  dad: EDad,
  dating: EDating,
  death: EDeath,
  design: EDesign,
  dreams: EDreams,
  environmental: EEnvironmental,
  equality: EEquality,
  experience: EExperience,
  failure: EFailure,
  faith: EFaith,
  family: EFamily,
  famous: EFamous,
  fear: EFear,
  fitness: EFitness,
  forgiveness: EForgiveness,
  freedom: EFreedom,
  friendship: EFriendship,
  funny: EFunny,
  future: EFuture,
  god: EGod,
  good: EGood,
  government: EGovernment,
  graduation: EGraduation,
  great: EGreat,
  happiness: EHappiness,
  history: EHistory,
  home: EHome,
  hope: EHope,
  humor: EHumor,
  imagination: EImagination,
  inspirational: EInspirational,
  intelligence: EIntelligence,
  jealousy: EJealousy,
  knowledge: EKnowledge,
  leadership: ELeadership,
  learning: ELearning,
  legal: ELegal,
  life: ELife,
  love: ELove,
  marriage: EMarriage,
  medical: EMedical,
  men: EMen,
  mom: EMom,
  money: EMoney,
  morning: EMorning,
  movies: EMovies,
  success: ESuccess,
}
